import React from 'react';
import Button from '@mui/material/Button';
import { generateTestId } from 'app/functions';
import { styled } from '@mui/material';

const StyledButton = styled(Button)(({ theme }) => ({
    width: '100%',
    borderRadius: '12px',
    fontSize: '16px',
    height: '41px',
    fontSize: '16px',
    [theme.breakpoints.up('md')]: {
        fontSize: '20px',
        height: '52px',
        borderRadius: '18px',
    },
    [theme.breakpoints.up('lg')]: {
        height: '62px',
        fontSize: '24px',
        borderRadius: '24px',
    },
}));



const HotActionButton = ({ 
    onClick, 
    children, 
    disabled = false,
    variant = 'contained',
    size = 'medium',
    className = '',
    startIcon = null,
    endIcon = null,
    testID = '',
    fullWidth = false,
    ...rest
}) => {
    return (
        <StyledButton
            className={className}
            onClick={onClick}
            disabled={disabled}
            variant={variant}
            size={size}
            startIcon={startIcon}
            endIcon={endIcon}
            fullWidth={fullWidth}
            testID={generateTestId(testID, 'hot-action-button')}
            {...rest}
        >
            {children}
        </StyledButton>
    );
};

export default HotActionButton; 